
import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import useCountAnimation from '../../hooks/useCountAnimation';
import conversion_example from '../../assets/sportsbet-conversion-example.png';
import './ConversionWizard.css';

const ConversionWizard = () => {
  const [featureRef, featureInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const [exampleRef, exampleInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const features = [
    {
      title: "Comprehensive Search",
      description: "Scans across 12 major bookmakers and all major sports to find the best opportunities",
      icon: "🔍"
    },
    {
      title: "Smart Rankings",
      description: "Find top conversions instantly or view the best 10 options for flexibility",
      icon: "📊"
    },
    {
      title: "Time Efficiency",
      description: "What takes 15+ minutes manually can be found in seconds with better quality matches",
      icon: "⚡"
    }
  ];

  return (
    <div className="conversion-wizard">
      <section className="hero-container">
        <div className="hero-content">
          <h1 className="slide-up">Conversion Wizard</h1>
          <p className="hero-subtitle slide-up-delay">Transform your bonus bets into real cash with our intelligent conversion system</p>
          <div className="hero-stats slide-up-delay-2">
            <div className="stat">
              <span className="stat-number">{useCountAnimation(15)}<span className="stat-unit">min</span></span>
              <span className="stat-label">Update Frequency</span>
            </div>
            <div className="stat">
              <span className="stat-number">{useCountAnimation(14)}<span className="stat-unit">Days</span></span>
              <span className="stat-label">Scanned Ahead</span>
            </div>
            <div className="stat">
              <span className="stat-number">{useCountAnimation(12)}</span>
              <span className="stat-label">Bookmakers supported</span>
            </div>
          </div>
        </div>
      </section>

      <section className="example-section" ref={exampleRef}>
        <div className={`example-container ${exampleInView ? 'fade-in' : ''}`}>
          <div className="example-content">
            <h2>How It Works</h2>
            <p>Our system automatically finds the best conversion opportunities across the major supports. Using our custom searches you can specify your odds, bookmaker and even bonus size allowing you find the perfect bet size to hedge your bonus</p>
          </div>
          <div className="example-image">
            <img src={conversion_example} alt="Conversion Example" />
          </div>
        </div>
      </section>

      <section className="features" ref={featureRef}>
        <div className={`features-grid ${featureInView ? 'features-visible' : ''}`}>
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section">
        <div className="other-bots">
          <h2>Explore Our Other Tools</h2>
          <p>Complete your matched betting toolkit with our specialized bots</p>
          <div className="bot-links">
            <Link to="/betslips-tips" className="bot-link">
              <span className="bot-icon">🎯</span>
              <div className="bot-info">
                <h3>Betslips & Tips</h3>
                <p>Smart bet tracking and analysis</p>
              </div>
            </Link>
            <Link to="/mug-master" className="bot-link">
              <span className="bot-icon">🎲</span>
              <div className="bot-info">
                <h3>Mug Master</h3>
                <p>Account management optimization</p>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConversionWizard;
